import * as utils from '@utils/form';
import { TEXT_POSITIONS } from '@api/constants';
import { IMAGE_SIZE } from '@api/media/constants';

export const FEATURED_LINKS_COUNT = 2;

export const FORM_FIELD = {
  IMAGE: {
    name: 'image',
    label: 'Article image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['1000x600'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  ARTICLE: {
    name: 'article',
    label: 'Title:',
    rules: [{ required: true, message: 'This field is required' }],
    serialize: utils.relatedEntitySerializerForContentIdOrId,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Write a title',
    rules: [{ required: true, message: 'Title is required' }],
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Write a subtitle',
    rules: [{ required: true, message: 'Subtitle is required' }],
  },
  CATEGORY: {
    name: 'category',
    label: 'Category:',
    placeholder: 'Write a category',
    rules: [{ required: true, message: 'Category is required' }],
  },
  STANDFIRST: {
    name: 'standfirst',
    label: 'Standfirst:',
    placeholder: 'Write a short description',
    multiline: true,
    rules: [{ required: true, message: 'Category is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter a news story URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },

  LINKS: {
    name: 'links',
    type: 'array',
    deserialize: (field, data) => {
      const links = data[field.name];
      return { [field.name]: [...new Array(FEATURED_LINKS_COUNT)].map((_, i) => links[i] || {}) };
    },
    serialize: (field, values) => {
      const links = values[field.name];
      return {
        [field.name]: links.map((link) =>
          link.article ? { articleId: link.article.contentId || link.article.id } : link,
        ),
      };
    },
  },

  LINK_ARTICLE: (num) => ({
    name: [num, 'article'],
    placeholder: 'Start typing the title of the news story:',
    rules: [{ required: true, message: 'This field is required' }],
  }),
  LINK_TITLE: (num) => ({
    name: [num, 'title'],
    placeholder: 'Enter a title',
    rules: [{ required: true, message: 'Title is required' }],
  }),
  LINK_SUBTITLE: (num) => ({
    name: [num, 'subtitle'],
    placeholder: 'Enter a subtitle',
    rules: [{ required: true, message: 'Subtitle is required' }],
  }),
  LINK_URL: (num) => ({
    name: [num, 'url'],
    placeholder: 'Enter the URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  }),

  TEXT_POSITION: {
    name: 'textPosition',
    label: 'Text position:',
    positions: TEXT_POSITIONS,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  MANUAL: {
    value: 'manual',
    label: 'Add a news story manually',
  },
  EXISTING: {
    value: 'existing',
    label: 'Add an existing news story',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.TEXT_POSITION.name]: FORM_FIELD.TEXT_POSITION.positions[0].key,
  [FORM_FIELD.LINKS.name]: [],
};
